const Switch = ({ id, name, formik, checked }) => {
  const isChecked = formik ? formik.values[name] : checked || false;

  const handleCheckboxChange = () => {
    if (formik) {
      formik.setFieldValue(name, !isChecked);
    }
  };

  return (
    <label htmlFor={id} className="flex items-center cursor-pointer select-none">
      <div className="relative">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
          className="sr-only"
          id={id}
        />
        <div
          className={`block h-8 w-14 rounded-full transition-colors duration-300 ${
            isChecked ? "bg-sideBar" : "bg-white"
          }`}
        ></div>
        <div
          className={`absolute left-1 top-1 h-6 w-6 rounded-full transition transform duration-300 ${
            isChecked ? "translate-x-6 bg-white " : "bg-sideBar"
          }`}
        ></div>
      </div>
    </label>
  );
};

export default Switch;
